// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b0cf9c2b","453":"c5eaf93b"}[chunkId] + ".chunk.js";
};